import React, { useState } from 'react';
import { Box, Avatar, Menu, MenuItem, ListItemIcon, Divider, IconButton, Tooltip} from '@mui/material';
import { Logout } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AccountMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { currentRole, currentUser } = useSelector(state => state.user);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2, bgcolor: 'teal', '&:hover': { bgcolor: 'gold' }, transition: '0.3s' }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{ width: 36, height: 36, bgcolor: 'gold', color: 'teal', fontWeight: 'bold' }}>
                            {String(currentUser.name).charAt(0)}
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 5,
                    sx: styles.styledPaper,
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem sx={styles.menuItem}>
                    <Avatar sx={{ bgcolor: 'gold', color: 'teal' }} />
                    <Link to={`/${currentRole}/profile`} style={styles.link}>Profile</Link>
                </MenuItem>
                <Divider sx={{ bgcolor: 'gold' }} />
                <MenuItem sx={styles.menuItem}>
                    <ListItemIcon>
                        <Logout fontSize="small" sx={{ color: 'gold' }} />
                    </ListItemIcon>
                    <Link to="/logout" style={styles.link}>Logout</Link>
                </MenuItem>
            </Menu>
        </>
    );
};

export default AccountMenu;

const styles = {
    styledPaper: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 4px 12px rgba(0,0,0,0.4))',
        mt: 1.5,
        borderRadius: 2,
        bgcolor: 'teal',
        color: 'white',
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'teal',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
    menuItem: {
        '&:hover': {
            bgcolor: 'rgba(255, 215, 0, 0.3)',
            transform: 'scale(1.05)',
            transition: '0.3s',
        },
    },
    link: {
        textDecoration: 'none',
        color: 'white',
        fontWeight: 'bold',
        paddingLeft: 8,
    }
};
